import React, { memo, useState } from 'react';
import { Button } from 'react-bootstrap';
import LazyImage from '../../CustomLibraries/LazyImage';
import '../../../assets/sass/uiV3/component/_moduleCTA.scss';
import FormQuestionModal from '../../FormQuestionModal';
import { openNewTab, reactHtmlParser } from '../../../common/common';
import { toast } from 'react-toastify';
import axiosInstance from '../../../Store/helper/axiosInstance';

// type GraphicsObj = {
//   size: 'lg' | 'md' | 'sm';
//   color: string;
//   border: boolean;
//   position: 'left-top' | 'right-top' | 'left-bottom' | 'right-bottom';
// };

// type FormObj = {
//   label: string;
//   field_name: string;
//   type: string;
//   is_mandatory: '0' | '1';
//   options: string;
// };

// type LabelObj = {
//   isPresent: boolean;
//   text: string;
//   position: 'left' | 'right';
//   icon: string;
// };

// type BottomButton = {
//   isPresent: boolean;
//   position: 'left' | 'right' | 'center';
//   variant: 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'danger' | 'light' | 'dark';
// };

// type ItemAfterTitle = {
//   isPresent: boolean;
//   element: 'button' | 'logo' | '';
//   variant: 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'danger' | 'light' | 'dark';
// };

// type CardObject = {
//   ctaId: string;
//   ctaType: string;
//   title: string;
//   description: string;
//   cardBgImage: string;
//   logo: string;
//   buttonText: string;
//   buttonIcon: string;
//   cardBgColor: string;
//   bgOpacity: string;
//   cardVariant: 'primary' | 'light';
//   cardTextColor: string;
//   graphicsObj: GraphicsObj[];
//   labelObj: LabelObj;
//   bottomButton: BottomButton;
//   itemAfterTitle: ItemAfterTitle;
//   iconBeforeText: string;
//   buttonAction: 'new_page' | 'post' | 'form' | 'same_page' | '';
//   ctaUrl: string;
//   form: FormObj[];
//   onClick: () => void;
//   clickCallback: (ctaId: any) => void;
// };
const DynamicCTATemplateCard = ({
  logo,
  buttonText,
  bottomButton = {
    isPresent: false,
    position: 'right',
    variant: 'primary'
  },
  cardBgColor = '',
  cardVariant = 'light',
  buttonIcon = 'flaticon-next',
  cardBgImage = '',
  description = '',
  ctaId = '',
  bgOpacity = '',
  ctaType = '',
  cardTextColor = '',
  graphicsObj = [],
  iconBeforeText = '',
  buttonAction = '',
  ctaUrl = '',
  onClick,
  clickCallback,
  className = '',
  itemAfterTitle = {
    isPresent: false,
    element: '',
    variant: 'primary'
  },
  labelObj = {
    isPresent: false,
    text: '',
    position: 'left',
    icon: ''
  },
  title = '',
  form = []
}) => {
  const [show, setShow] = useState(false);
  const onHide = () => setShow(false);

  const onClickButton = () => {
    if (onClick && typeof onClick === 'function') {
      onClick();
    } else {
      clickCallback && clickCallback(ctaId);
      if (buttonAction?.toLowerCase() == 'form') {
        setShow(true);
      } else if (buttonAction?.toLowerCase() == 'new_page') {
        openNewTab(ctaUrl, () => {
          window.location.href = ctaUrl;
        });
      } else if (buttonAction?.toLowerCase() == 'same_page') {
        window.location.href = ctaUrl;
      }
    }
  };
  const postForm = async (userInput) => {
    console.log('user has clicked submit button');
    if (form.some((_q) => _q.is_mandatory == 1 && !userInput[_q.field_name])) {
      toast.error('Please fill all mandatory fields');
      return;
    }
    let response = await axiosInstance.post('cta/cta_submitted_forms', {
      cta_id: ctaId,
      cta_type: ctaType,
      submitted_form_json: userInput
    });
    console.log('response:', response);
    if (response.status == 200) {
      toast.success('Your Response submitted successfully');
      onHide();
    }
  };
  return (
    <>
      <div
        className={`w-100 overflow-hidden position-relative rounded-3 cursorPointer d-flex flex-column clr_v3_cornerGraphicsDynamic clr_v3_moduleCTA--dynamic ${
          cardVariant == 'light'
            ? 'bg-extra-light'
            : cardVariant == 'primary'
            ? 'bg-primary'
            : cardBgColor
            ? ''
            : 'bg-extra-light'
        } ${className}`}
        style={cardBgColor ? { backgroundColor: cardBgColor } : {}} // background color of card , if not selected then default value will be {} and bg-extra-light class will be called
      >
        {/* graphics section start */}
        <div
          className="position-absolute top-0 start-0 w-100 h-100 z-0 clr_v3_cornerGraphicsDynamic__Graphics z-0"
          style={{ opacity: bgOpacity || 0.09 }}
        >
          {cardBgImage ? (
            <LazyImage
              className="w-100 h-100 object-fit-cover"
              src={cardBgImage}
              alt={'image'}
              click={() => {}}
              extraClass=""
              fallback_image=""
              height=""
              logo={false}
              width=""
            />
          ) : (
            <>
              {graphicsObj.length > 0 &&
                graphicsObj.map((item, index) => {
                  let positions = item.position.split('-');
                  let color = item.color
                    ? item.border
                      ? { borderColor: item.color }
                      : { backgroundColor: item.color }
                    : {};
                  let lightClasses = item.border ? 'bordered border-primary' : 'bg-primary';
                  let primaryClasses = item.border ? 'bordered border-white' : 'bg-white';
                  return (
                    <div
                      key={'position_' + index}
                      className={`position-absolute rounded-circle graphics-size-${item.size} ${
                        positions[0]
                      } ${positions[1]} ${
                        item.color ? '' : cardVariant == 'light' ? lightClasses : primaryClasses
                      }`}
                      style={{
                        ...color
                      }}
                    />
                  );
                })}
            </>
          )}
        </div>
        {/* graphics section end */}

        {/* label start */}
        {labelObj.isPresent && (
          <div
            className={`bg-soft-primary rounded-4 rounded-top-0  py-2 px-3 d-inline-flex gap-2 align-items-center position-relative z-2 me-0 ${
              labelObj.position == 'left' ? 'rounded-start-0 me-auto' : 'rounded-end-0 ms-auto'
            }`}
          >
            {/* if position == left then me-auto  */}
            {labelObj?.icon && <i className={'fs-4 ' + labelObj.icon}></i>}
            {labelObj?.text}
          </div>
        )}
        {/* label end */}

        <div
          className={`d-flex flex-column px-sm-4 px-3 pb-3 pb-sm-4 gap-2 ${
            labelObj.isPresent ? 'pt-2' : 'pt-3 pt-sm-4'
          }`}
        >
          <div className="d-flex gap-4 justify-content-between align-items-start">
            <div
              className={`flex-grow-1 gap-2 d-flex ${
                cardVariant == 'light'
                  ? 'text-black'
                  : cardVariant == 'primary'
                  ? 'text-white'
                  : 'text-black'
              }`}
              style={cardTextColor ? { color: cardTextColor } : {}}
            >
              {iconBeforeText && <i className={'fs-3 flex-shrink-0 mt-33 ' + iconBeforeText}></i>}
              <h2 className={`fs-16 fw-semibold flex-grow-1 `}>{reactHtmlParser(title)}</h2>
            </div>
            {itemAfterTitle.isPresent &&
              (itemAfterTitle.element == 'button' ? (
                <Button
                  size="sm"
                  onClick={onClickButton}
                  variant={
                    itemAfterTitle?.variant
                      ? itemAfterTitle.variant
                      : cardVariant == 'light'
                      ? 'primary'
                      : 'light'
                  }
                  style={
                    itemAfterTitle.variant
                      ? {
                          backgroundColor: itemAfterTitle.variant
                        }
                      : {}
                  }
                  className="text-nowrap d-flex align-items-center justify-content-center gap-2 flex-shrink-0"
                >
                  {buttonText}{' '}
                  {buttonIcon && <i className={'fs-3 ms-2 text-black' + buttonIcon}></i>}
                </Button>
              ) : (
                <div className="clr_v3_sponsor text-right me-0 flex-shrink-0">
                  <div className="clr_v3_sponsor_slide w-100 position-relative">
                    <LazyImage
                      src={logo}
                      className="mw-100 mh-100 position-absolute translate-middle-y end-0 top-50"
                      alt={'image'}
                      click={() => {}}
                      extraClass=""
                      fallback_image=""
                      height=""
                      logo={true}
                      width=""
                    />
                  </div>
                </div>
              ))}
          </div>
          {description && (
            <h4
              className={`fs-4 ${
                cardVariant == 'light'
                  ? 'text-black'
                  : cardVariant == 'primary'
                  ? 'text-white'
                  : 'text-black'
              }`}
              style={{
                opacity: 0.99
              }}
            >
              {reactHtmlParser(description)}
            </h4>
          )}
          {bottomButton.isPresent && (
            <div className="mt-1 d-flex">
              <Button
                size="sm"
                variant={
                  bottomButton?.variant
                    ? bottomButton.variant
                    : cardVariant == 'light'
                    ? 'primary'
                    : 'light'
                }
                onClick={onClickButton}
                className={
                  'text-nowrap d-flex align-items-center justify-content-center gap-2 flex-shrink-0 ' +
                  (bottomButton.position === 'left'
                    ? 'me-auto'
                    : bottomButton.position === 'right'
                    ? 'ms-auto'
                    : bottomButton.position === 'center'
                    ? 'mx-auto'
                    : '')
                }
              >
                {buttonText}
                {buttonIcon && <i className={buttonIcon}></i>}
              </Button>
            </div>
          )}
        </div>
      </div>
      {form.length > 0 && buttonAction === 'form' && (
        <FormQuestionModal show={show} onHide={onHide} submitClick={postForm} form={form} />
      )}
    </>
  );
};

export default memo(DynamicCTATemplateCard);
